var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Glow = function () {
  EHDI.aka.Container.call(this);

  this._glow = new EHDI.aka.Sprite(EHDI.Assets.images['fx_firsttimeplay_glow']);
  this._glow.anchor.x = 0.5;
  this._glow.anchor.y = 0.5;

  this._scaleUp = false;
  this._currentScale = 1;

  this.addChild(this._glow);
}

EHDI.game.Glow.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Glow.prototype.update = function () {
  this.rotation += 0.02;

  if (this._scaleUp) {
    this._currentScale += 0.006;
    if (this._currentScale >= 1) {
      this._scaleUp = false;
      this._currentScale = 1;
    }
  } else {
    this._currentScale -= 0.006;
    if (this._currentScale <= 0.8) {
      this._scaleUp = true;
      this._currentScale = 0.8;
    }
  }

  this.scale.x = this._currentScale;
  this.scale.y = this._currentScale;
}

EHDI.game.Glow.prototype.reset = function () {
  this.rotation = 0;

  this._currentScale = 1;
  this.scale.x = 1;
  this.scale.y = 1;

  this._scaleUp = false;
}

EHDI.game.Glow.prototype.destroy = function () {

  if(this._glow != null)
  {
    this.removeChild(this._glow);
    this._glow.destroy({children: true});
  }
  delete this._glow;

  this._currentScale = null;
  this._scaleUp = null;
}
